export default "__VITE_ASSET__bd644fcb__"